<app-ip-title-mobile
    [back]="true"
    [title]="'IP.TABLE.CONSOLIDATED-DETAIL.TITLE' | translate" ></app-ip-title-mobile>
<div class="consolidated-details__header" *ngIf="dataOk">
  <div class="consolidated-details__header-data">
    <b> {{ "IP.CONSOLIDATED.DETAILS.NAME" | translate }} </b> {{ currentConsolidate.name ?? '-' }}
  </div>
  <div class="consolidated-details__header-data">
    <b> {{ "IP.CONSOLIDATED.DETAILS.CREATED_BY" | translate }}  </b> {{ currentConsolidate.createdBy ?? '-' }}
  </div>
  <div class="consolidated-details__header-data">
    <b> {{ "IP.CONSOLIDATED.DETAILS.MODIFIED_BY" | translate }} </b> {{ currentConsolidate.modifiedBy ?? '-' }}
  </div>
  <div class="consolidated-details__header-data">
    <b> {{ "IP.CONSOLIDATED.DETAILS.LAST_MODIFIED" | translate }}  </b> {{ currentConsolidate.lastModificationDate ?? '-' }}
  </div>
</div>
<app-fn-tables
  [tableOption]="tableOptions"
  [propertyOrder]="propertyOrder"
  (action)="onAction($event)"
  [pageItems]="50"
  [filter]="false"
  service="consolidated-detail"
  [dateFiltersActive]="false"
  (dataOk)="dataOk = true"
  [dataChange]="dataChange"
/>
<div class="consolidated-details__btn" *ngIf="dataOk">
  <app-ip-button-modal 
  [typeBtn]="'action'"
  (clicked)="downloadCsv()"
  [styleButton]="'width: 10rem;'"
  >
  <div class="consolidated-details__btn-content">
    <img src="./assets/icons/download-icon.svg" alt=""/>
    {{ "IP.CONSOLIDATED.DETAILS.DOWNLOAD" | translate }} 
    </div>
 </app-ip-button-modal>
</div>